var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStatisticsUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#statistics_user_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#B7B7C2",
  d: "M11.5 6c1.054 0 1.917.9 1.917 2s-.863 2-1.917 2-1.916-.9-1.916-2 .862-2 1.916-2m0 9c2.588 0 5.558 1.29 5.75 2v1H5.75v-.99C5.942 16.29 8.913 15 11.5 15m0-11C9.382 4 7.667 5.79 7.667 8s1.715 4 3.833 4 3.834-1.79 3.834-4-1.716-4-3.834-4m0 9c-2.559 0-7.666 1.34-7.666 4v3h15.333v-3c0-2.66-5.108-4-7.667-4"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "statistics_user_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h23v24H0z"
})))));
export default SvgStatisticsUser;